import React from 'react';
import Header from '../../../Components/Header/Header';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import Footer from '../../../Components/Footer/Footer.js';
import Orders from '../../../Components/Orders/Orders';

const ExploreAll = () => {
    return (
        <>
            <Header/>
            <Sidebar/>
            <Orders/>
            <Footer/>
        </>
    );
};

export default ExploreAll;